import React from 'react';
import PropTypes from 'prop-types';

/**
 * Spinner component for web
 *
 * Loading indicator for async operations
 */
const Spinner = ({
  size = 'md',
  color = 'primary',
  className = '',
  centered = false,
  label,
  ...props
}) => {
  const sizeClasses = {
    sm: 'spinner-sm',
    md: 'spinner-md',
    lg: 'spinner-lg',
  };

  const colorClasses = {
    primary: 'text-primary-700',
    accent: 'text-accent-600',
    white: 'text-white',
    neutral: 'text-neutral-600',
  };

  const spinnerClasses = [
    'spinner',
    sizeClasses[size],
    colorClasses[color],
    className,
  ].filter(Boolean).join(' ');

  const spinner = (
    <div
      className={spinnerClasses}
      role="status"
      aria-label={label || 'Loading'}
      {...props}
    >
      <span className="sr-only">{label || 'Loading...'}</span>
    </div>
  );

  if (centered) {
    return (
      <div className="flex items-center justify-center w-full h-full">
        {spinner}
      </div>
    );
  }

  return spinner;
};

Spinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.oneOf(['primary', 'accent', 'white', 'neutral']),
  className: PropTypes.string,
  centered: PropTypes.bool,
  label: PropTypes.string,
};

export default Spinner;
